import type { ReactNode } from "react";
import { Icon, StarMark } from "@core/icons";
import "./access.css";

// Columna mobile-first, sin tarjeta centrada de escritorio: el prototipo es
// full-bleed (`validador.jsx:590-605`, `maxWidth: 480`), pensado para el
// navegador del celular de mostrador — a diferencia del portal
// (`portal/access/AccessLayout.tsx`), que sí adapta a una tarjeta de
// escritorio porque su usuario ya está sentado frente a un monitor.
export function Shell({ children }: { children: ReactNode }) {
  return <main className="sc-shell">{children}</main>;
}

// Adaptación de `Marca` (`validador.jsx:113-121`).
export function Brand({ sub }: { sub?: string }) {
  return (
    <div className="sc-brand">
      <div className="sc-brand-mark">
        <StarMark size={50} ring stroke={1} />
      </div>
      <div className="sc-brand-title">Star Circle</div>
      {sub ? <div className="sc-brand-sub">{sub}</div> : null}
    </div>
  );
}

// Adaptación del botón "Volver" de `Recuperar`/`NuevaClave`
// (`validador.jsx:161-163`, `:212-214`).
export function BackButton({ onClick }: { onClick: () => void }) {
  return (
    <button type="button" onClick={onClick} className="sc-back">
      <Icon name="arrow" size={18} />
      Volver
    </button>
  );
}
